<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filters
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <template v-for="filter in filters ">
          <template v-if="filter.type !== FieldType.HIDE">
            <b-col
                cols="12"
                md="4"
                class="mb-md-0 mb-2"
            >
              <label> {{ filter.label }}</label>
              <b-form-input v-if="filter.type === FieldType.TEXT"
                            v-model="filter.value.value"
                            @input="(val) =>  {
                             $emit(`update:${filter.name}Filter`, val)
                         }"
                            trim
              />
              <v-select v-if="filter.type === FieldType.SELECT_ARRAY"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        v-model="filter.value.value"
                        :options="filter.refs.value"
                        class="w-100"
                        @input="(val) =>  {
                        $emit(`update:${filter.name}Filter`, val)
                      }"
              />
            </b-col>
          </template>
        </template>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput
} from 'bootstrap-vue'
import {FormConfig, PropertyConfig, FieldType, Filter, Operator} from "./index.d.ts";

import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    vSelect,
  },
  props: {
    formConfig: {
      type: FormConfig,
      required: true,
    },
  },

  setup(props, {emit}) {
    const filters = props.formConfig.filters
    console.log(filters)
    return {
      filters,
      FieldType,
      console,
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
